import { styled } from "theme/default/styled";
import { setFlexDFJCC } from "theme/setter/setFlexValues/setFlexDFJCC";

export const SCheckboxFilterDelete = styled.button`
  align-content: center;
  margin-left: 8px;

  ${setFlexDFJCC};
`;
